module.exports = __webpack_public_path__ + "static/media/11-3.95847e7b.mp3";